import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=48c97d3b&scoped=true&"
import script from "./Employment.vue?vue&type=script&lang=js&"
export * from "./Employment.vue?vue&type=script&lang=js&"
import style0 from "./Employment.vue?vue&type=style&index=0&id=48c97d3b&lang=scss&scoped=true&"
import style1 from "./Employment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c97d3b",
  null
  
)

export default component.exports